import { Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { REVIEWS } from "../data/content";

export const Reviews = () => (
  <section data-testid="reviews-section" className="border-y hairline bg-ink py-16 texture-brushed">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="flex flex-col items-start gap-10 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span data-testid="reviews-score" className="font-display text-5xl font-bold text-white">5.0</span>
              <div>
                <div className="flex gap-1 text-bronze">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={16} fill="currentColor" />
                  ))}
                </div>
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-white/50">Vlerësimi në Google</p>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-3" data-testid="reviews-list">
            {REVIEWS.map((r) => (
              <div key={r.name} data-testid={`review-${r.name.replace(/\s+/g, "-").toLowerCase()}`} className="border hairline px-5 py-3">
                <div className="flex gap-0.5 text-bronze">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={11} fill="currentColor" />
                  ))}
                </div>
                <p className="mt-2 font-display text-sm font-semibold text-white/85">{r.name}</p>
                <p className="text-xs text-white/40">{r.when} · Google</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
